import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./form-group.scss";

import Button from "../../Button/Button";
import ButtonGroup from "../../ButtonGroup/ButtonGroup";
import ButtonGroupRow from "../../ButtonGroup/ButtonGroupRow";

let timeoutID;

class FormGroup extends Component {
  constructor(props) {
    super(props);

    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);

    this.formGroupRef = createRef();
  }

  handleOnBlur(e) {
    const { onFocusBlur } = this.props;
    timeoutID = setTimeout(() => {
      if (!this.formGroupRef.current.contains(e.relatedTarget)) {
        if (!this.formGroupRef.current.isEqualNode(e.relatedTarget)) {
          onFocusBlur(null);
        }
      }
    }, 0);
  }

  handleOnFocus() {
    const { focusedFormGroup, id, onFocusBlur } = this.props;
    const isManagingFocus = focusedFormGroup === id;
    clearTimeout(timeoutID);

    if (!isManagingFocus) {
      onFocusBlur(id);
    }
  }

  render() {
    const { children, className, canSubmit, focusedFormGroup, id } = this.props;

    const classes = classnames(
      "form-group",
      { "form-group--has-focus": focusedFormGroup === id },
      className
    );

    return (
      <div
        tabIndex="-1"
        className={classes}
        ref={this.formGroupRef}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
      >
        <div className="form-group__inner u-margin-bottom-2">{children}</div>
        <ButtonGroup>
          <ButtonGroupRow buttonAlignment="space-between">
            <Button text="Cancel" variant="link" onClick={() => {}} />
            <Button text="Save" variant="primary" disabled={!canSubmit} onClick={() => {}} />
          </ButtonGroupRow>
        </ButtonGroup>
      </div>
    );
  }
}

FormGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  canSubmit: PropTypes.bool.isRequired,
  focusedFormGroup: PropTypes.string,
  id: PropTypes.string.isRequired,
  onFocusBlur: PropTypes.func.isRequired,
};

export default FormGroup;
